<!--管理员房型管理-->
<template>
  <div>
      <div class="mt-4" v-for="item in list" :key="item.id">
        <public-title>
        {{ item.title }}<span v-if="item.assist">({{ item.assist }})</span>
        </public-title>
        <div class="img-ipc">
          <upload-image @fileChange="(imgs)=>{lobbyImgs = imgs;}" :existImgs="item.pic" :maxLength="20"/>
          <div class="img-box" @click="clickUpload(item)">
            <i class="iconfont icon-tianjiatupian"></i>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex' 
export default {
  name: '',
  components: {},
  props: {
    list: {
      type: Object,
      default: () => ({})
    },
    list: {
      type: Array,
      default: () => []
    },  
  },
  data() {
    return {
    };
  },
  computed: {},
  watch: {},
  created() {
  },
  mounted() {
    console.log('123')
  },
  methods: {
    ...mapActions(['HotelsRoomList']),
    clickUpload(item){
      this.$emit('uploadPic',item)
      console.log(item)
    }
  }
};
</script>

<style lang="scss" scoped>
  .bottom{
    display: flex;
  }
  .img-ipc{
    display: flex;
  }
  .img-box{
    width: 70px;
    height: 70px;
    border: 1px solid #eee;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    .icon-tianjiatupian{
      color: #999;
      font-size: 26px;
      cursor: pointer;
    }
  }
</style>
